import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
const control = 'w-full rounded-xl border bg-white px-4 py-3 text-[15px] text-ink placeholder:text-ink-faint transition-colors duration-200 ease-smooth focus:outline-none';
const normal = 'border-line hover:border-ink/25 focus:border-accent';
const invalid = 'border-danger focus:border-danger';
interface BaseProps {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  className?: string;
  id: string;
}
function Wrapper({
  label,
  hint,
  error,
  required,
  id,
  className = '',
  children
}: BaseProps & {
  children: React.ReactNode;
}) {
  return <div className={className} data-id="element-201" data-mp="hv2zn2v5hsjt">
      <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-ink" data-id="element-202" data-mp="hw4c9brten3n">
        {label}
        {required && <span className="ml-1 text-accent" data-id="element-203" data-mp="rrxyjmvc5uym">*</span>}
      </label>
      {children}
      {error ? <p className="mt-1.5 text-xs font-medium text-danger" data-id="element-204" data-mp="wr27cceclqof">{error}</p> : hint && <p className="mt-1.5 text-xs text-ink-muted" data-id="element-205" data-mp="woofsdivmwlm">{hint}</p>}
    </div>;
}
export function TextField({
  label,
  hint,
  error,
  required,
  className,
  id,
  ...rest
}: BaseProps & React.InputHTMLAttributes<HTMLInputElement>) {
  return <Wrapper label={label} hint={hint} error={error} required={required} id={id} className={className} data-id="element-206" data-mp="oe1gnii9kepf">
      <input id={id} required={required} aria-invalid={error ? true : undefined} className={`${control} ${error ? invalid : normal}`} {...rest} data-id="element-207" data-mp="kczoflmrl2wy" />
    </Wrapper>;
}
export function TextArea({
  label,
  hint,
  error,
  required,
  className,
  id,
  rows = 5,
  ...rest
}: BaseProps & React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <Wrapper label={label} hint={hint} error={error} required={required} id={id} className={className} data-id="element-208" data-mp="139r7pv2b3i10">
      <textarea id={id} rows={rows} required={required} aria-invalid={error ? true : undefined} className={`${control} ${error ? invalid : normal} resize-y`} {...rest} data-id="element-209" data-mp="1ztzwc57y5yzm" />
    </Wrapper>;
}
export function SelectField({
  label,
  hint,
  error,
  required,
  className,
  id,
  options,
  ...rest
}: BaseProps & React.SelectHTMLAttributes<HTMLSelectElement> & {
  options: {
    value: string;
    label: string;
  }[];
}) {
  return <Wrapper label={label} hint={hint} error={error} required={required} id={id} className={className} data-id="element-210" data-mp="3khsm5p3x2z9k">
      <div className="relative" data-id="element-211" data-mp="36i9pbsgk3ack">
        <select id={id} required={required} className={`${control} ${error ? invalid : normal} appearance-none pr-10`} {...rest} data-id="element-212" data-mp="36lfe16l9wa7r">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-213" data-mp="31jq0nkakvkgi">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-faint" aria-hidden="true" data-id="element-214" data-mp="uutk833ardw7" />
      </div>
    </Wrapper>;
}